export default __webpack_public_path__ + "6fca818b0a2618c20fffc1b76e5b86a0.svg";